import { render, staticRenderFns } from "./attachment-dialog.vue?vue&type=template&id=41503046&scoped=true"
import script from "./attachment-dialog.vue?vue&type=script&lang=js"
export * from "./attachment-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41503046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41503046')) {
      api.createRecord('41503046', component.options)
    } else {
      api.reload('41503046', component.options)
    }
    module.hot.accept("./attachment-dialog.vue?vue&type=template&id=41503046&scoped=true", function () {
      api.rerender('41503046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/attachment-dialog.vue"
export default component.exports